import { AlertColor } from '@mui/material';
import VibToast, { SnackbarContent } from '@vibTheme/components/VibToast';
import { useSession } from 'next-auth/react';
import { createContext, PropsWithChildren, useState } from 'react';

interface ToastContextValue {
  setContent: (message: string, type?: AlertColor) => void;
  handleError: (err: any, fallbackMessage: string) => void;
}

export const ToastContext = createContext({} as ToastContextValue);

export function ToastContextProvider({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false);
  const [snackbar, setSnackbar] = useState<SnackbarContent>({
    type: 'success',
    message: '',
  });

  function setContent(message: string, type?: AlertColor) {
    setSnackbar({ message, type });
    setOpen(true);
  }

  const session = useSession();
  function handleError(err: any, fallbackMessage: string) {
    window.NREUM?.noticeError(err, {
      message: fallbackMessage,
      user: session?.data?.user,
    });

    const message =
      typeof err.detail === 'string' ? err.detail : fallbackMessage;
    setSnackbar({ message, type: 'error' });
    setOpen(true);
  }

  return (
    <ToastContext.Provider value={{ setContent, handleError }}>
      {children}
      <VibToast content={snackbar} open={open} setOpen={setOpen} />
    </ToastContext.Provider>
  );
}
